export default __webpack_public_path__ + "static/solution-ona-67f3bcc3a6053a27303b60e193c8297d.mp4";